<template>
    <body>
        <div class="top">
            <div class="top1280">
                <div class="topText1" @click="$router.push('/')">首页 /</div>
                <div class="topText2">优秀学员认定</div>
            </div>
        </div>
        <div class="whiteContent">
            <div class="white1280">
                <img src="~@/assets/globalCourse/优秀学员认定奖杯内容.png" alt="" class="whiteIcon">
            </div>
        </div>
    </body>
</template>
<script>
import {rootUrl} from '@/globalConfig'
    export default {
      name: "excellentRecognition",
      data() {
        return {
            
        };
      },
      methods: {
        getKey() {
          return localStorage.getItem("token");
        },
         //实名权限检查与处理（培训班版）
        checkAndHandleAuthentication(){
          console.log("进入实名检查")
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          console.log(loginUserId,authentication)
          console.log(localStorage.getItem('preRoute'))
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/learn/excellentRecognition')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/learn/excellentRecognition')
        }
        return true;
      },
      //带权限判断的跳转
      jumpWithPermission(type,path,fromUrl){
          //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
          //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(type=='可游客'){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }else if(type=='仅登录'){
            //已登录
            if(loginUserId){
              if(fromUrl){
                window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+path,"_self")
              }
            }
            //未登录
            else {
              if(fromUrl){
                window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
              }
              else {
                window.open(rootUrl+'/Login',"_self")
              }
            }
          }else if(type=='仅实名'){
            //已登录
            if(loginUserId){
              //已实名
              if(authentication=='0'){
                if(fromUrl){
                  window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                  window.open(rootUrl+path,"_self")
                }
              }
              //未实名
              else {
                window.open(rootUrl+'/Authentication',"_self")
              }

            }
            //未登录
            else {

              if(fromUrl){
                window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                // this.$router.push('/Login')
              }
              else {
                window.open(rootUrl+'/Login',"_self")
              }
            }
          }
        },
      goLogin(){
            let url = "/excellentRecognition";
            this.$router.push({path:"/Login?returnUrl=" + url})
        },
      },
      mounted() {
        this.checkAndHandleAuthentication()
      },
      watch:{
      },
      computed: {
        
      },
    };
    </script>
<style scoped>
    .top{
        position: relative;
        margin-top: 120px;
        width: 100%;
        height: 54px;
        background: #F5F5F6;
    }
    .top1280{
        position: absolute;
        width: 1280px;
        height: 54px;
        left: calc(50% - 640px);
    }
    .topText1{
        position: absolute;
        left: 0px;
        width: 46px;
        height: 22px;
       font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #979797;
        line-height: 54px;
        cursor: pointer;
    }
    .topText2{
        position: absolute;
        left: 56px;
        width: 96px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 54px;
    }
    .whiteContent{
        position: relative;
        width: 100%;
        height: 1210px;
    }
    .white1280{
        position: absolute;
        width: 1280px;
        height: 1210px;
        left: calc(50% - 640px);
    }
    .whiteIcon{
        position: absolute;
        width: 800px;
        height: 950px;
        top: 72px;
        left: calc(50% - 400px);
    }
</style>